module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[110]231.bc9a0a7.woff2";